"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var OrderStatusHeader = function () {
    return (0, preact_1.h)("div", { class: "order-status-header" }, "Order Status");
};
exports.default = OrderStatusHeader;
